export class PdfPreviewer {
  public show(dataUrl: string, embed: HTMLEmbedElement | null) {
    if (!embed) {
      return;
    }
    const nextSrc = dataUrl + '#toolbar=0&navpanes=0&scrollbar=1&view=FitV';
    embed.type = 'application/pdf';
    if (embed.src === nextSrc) {
      embed.removeAttribute('src');
      requestAnimationFrame(() => {
        embed.src = nextSrc;
      });
    } else {
      embed.src = nextSrc;
    }
    embed.style.display = 'block';
  }

  public clear(embed: HTMLEmbedElement | null) {
    if (!embed) {
      return;
    }
    embed.removeAttribute('src');
    embed.style.display = 'none';
  }
}
